module.exports = __webpack_public_path__ + "static/media/suite-case-colorful.0b33744e.svg";